<!-- =========================================================================================
  File Name: VerticalNavMenuGroup.vue
  Description: Vertical NavMenu Group Component. Extends vuesax framework's 'vs-sidebar-group' component
  Component Name: VerticalNavMenuGroup
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class  = "vs-sidebar-group"
    :class = "[
      {'vs-sidebar-group-open'            : openItems        },
      {'vs-sidebar-group-active'          : open             },
      {'disabled-item pointer-events-none': group.isDisabled }
    ]"
    :data-hash="group.hash"
    :data-remove="group.remove"
    @mouseover = "mouseover"
    @mouseout  = "mouseout">

      <!-- Group Label -->
      <div @click="clickGroup" :class="[
        {'group-header': true},
        {'w-full': true},
        {'cursorMove': cursorMove}]">
        <span class="flex items-center w-full">

          <!-- Group Icon -->
          <feather-icon
            v-if        = "group.icon  || (this.groupIndex > Math.floor(this.groupIndex))"
            :icon       = "group.icon  || 'CircleIcon'"
            :svgClasses = "{ 'w-3 h-3' : this.groupIndex % 1 != 0 }" />

          <!-- Group Name -->
          <span v-show="!verticalNavMenuItemsMin" class="truncate mr-3 select-none">{{ $t(group.i18n) || ($i18n.locale === 'en' && group.name_en ? group.name_en : group.name) }}</span>

          <!-- Group Tag -->
          <feather-icon icon="Edit2Icon" @click="editButtonClick(group.hash)" v-if="$route.name === 'menu-builder'" svgClasses="h-4 w-4" class="ml-auto text-primary" style="cursor: pointer;"/>
          <feather-icon icon="TrashIcon" @click="deleteButtonClick(group.hash)" v-if="$route.name === 'menu-builder'" svgClasses="h-4 w-4 mr-4"  class="text-danger" style="cursor: pointer;"/>
          <vs-chip class="ml-auto mr-4" :color="group.tagColor" v-if="group.tag && !verticalNavMenuItemsMin">{{ group.tag }}</vs-chip>
        </span>

        <!-- Group Collapse Icon -->
        <feather-icon
          v-show     = "!verticalNavMenuItemsMin"
          :class     = "[{'rotate90' : openItems}, 'feather-grp-header-arrow']"
          :icon       = "$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
          svg-classes= "w-4 h-4" />

        <!-- Group Tooltip -->
        <span class="vs-sidebar--tooltip">{{ $t(group.i18n) || ($i18n.locale === 'en' && group.name_en ? group.name_en : group.name) }}</span>
      </div>
      <!-- /Group Label -->

      <!-- Icon PopUp -->

        <vs-popup id="select-icon" title="Selecione um ícone" :active.sync="chooseIcon">
          <div class="vx-row">
            <div class="vx-col w-full mt-2" style="margin-bottom: 50px!important;">
              <label class="vs-input--label">Ícone</label>
              <v-select
                  class="icon-select"
                  v-model="icon"
                  :options="iconOptions"
                  label="name"
                >
                <template v-slot:option="option">
                  <feather-icon :icon="option.value" svgClasses="h-5 w-5 mr-4 hover:text-warning cursor-pointer"/> {{ option.name }}
                </template>
              </v-select>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:1/2 w-full mt-2">
              <vs-button class="ml-auto mt-2" @click="saveIcon">Enviar</vs-button>
            </div>
          </div>
        </vs-popup>

      <!-- /Icon PopUp -->

      <!-- Group Items -->
        <ul ref="items" :style="styleItems" class="vs-sidebar-group-items">
          <template v-if="$route.name === 'menu-builder'">
            <draggable :animation="500" group="menu-items" @end="onEnd">
              <li v-for="(groupItem, index) in group.submenu" :key="groupItem.hash + Math.random()" style="list-style-type: none;">

                <!-- If item is group -->

                <v-nav-menu-group
                  v-if="groupItem.submenu"
                  :group      = "groupItem"
                  :groupIndex = "Number(`${groupIndex}.${index+1}`)"
                  :open       = "true"
                  :openHover  = "openHover"
                  :cursorMove = "true"
                  :hash="groupItem.hash"
                  :key="groupItem.hash + Math.random()"
                  :remove="groupItem.remove" />
                  <!-- {{ groupItem.remove }} -->

                <!-- Else: Item -->

                <v-nav-menu-item
                  icon-small
                  :index  = "groupIndex + '.' + index"
                  :to="groupItem.slug !== 'external' ? groupItem.url : null"
                  :href="groupItem.slug === 'external' ? groupItem.url : null"
                  :icon   = "itemIcon(groupIndex + '.' + index)"
                  :slug   = "groupItem.slug"
                  :target = "groupItem.target"
                  :cursorMove = "true"
                  :hash="groupItem.hash"
                  :key="groupItem.hash + Math.random()"
                  :remove="groupItem.remove">
                  <!-- {{ groupItem.remove }} -->
                    <span class="truncate">{{ $t(groupItem.i18n) || ($i18n.locale === 'en' && groupItem.name_en ? groupItem.name_en : groupItem.name) }}</span>
                    <vs-chip class="ml-auto" :color="groupItem.tagColor" v-if="groupItem.tag">{{ groupItem.tag }}</vs-chip>
                    <feather-icon icon="Edit2Icon" @click="editButtonClick(groupItem.hash)" svgClasses="h-4 w-4" class="ml-auto text-primary" style="cursor: pointer;"/>
                    <feather-icon icon="TrashIcon" @click="deleteButtonClick(groupItem.hash)" svgClasses="h-4 w-4"  class="text-danger" style="cursor: pointer;"/>
                </v-nav-menu-item>

              </li>
            </draggable>
          </template>

          <template v-else>
            <li v-for="(groupItem, index) in group.submenu" :key="groupItem.hash + Math.random()">

              <!-- {{ groupItem }} -->

                <!-- If item is group -->
                <v-nav-menu-group
                  v-if="groupItem.submenu"
                  :group      = "groupItem"
                  :groupIndex = "Number(`${groupIndex}.${index+1}`)"
                  :open       = "true"
                  :openHover  = "openHover" />

                <!-- Else: Item -->
                <v-nav-menu-item
                  v-else
                  icon-small
                  :index  = "groupIndex + '.' + index"
                  :to="groupItem.slug !== 'external' ? groupItem.url : null"
                  :href="groupItem.slug === 'external' ? groupItem.url : null"
                  :icon   = "itemIcon(groupIndex + '.' + index)"
                  :slug   = "groupItem.slug"

                  :target = "groupItem.target">
                    <span class="truncate">{{ $t(groupItem.i18n) || ($i18n.locale === 'en' && groupItem.name_en ? groupItem.name_en : groupItem.name) }}</span>
                    <vs-chip class="ml-auto" :color="groupItem.tagColor" v-if="groupItem.tag">{{ groupItem.tag }}</vs-chip>
                </v-nav-menu-item>

              </li>
          </template>
        </ul>
      <!-- /Group Items -->
  </div>
</template>


<script>
import VNavMenuItem from './VerticalNavMenuItem.vue'
import draggable from 'vuedraggable'
import vSelect from 'vue-select'

export default {
  name  : 'v-nav-menu-group',
  props : {
    openHover  : { type: Boolean, default: false },
    open       : { type: Boolean, default: false },
    group      : { type: Object                  },
    groupIndex : { type: Number                  },
    cursorMove : {type: Boolean,  default: false },
    hash       : {type: String,  default: ''     },
    remove     : {type: Boolean, default: false  }
  },
  components: {
    VNavMenuItem,
    draggable,
    vSelect
  },
  data: () => ({
    maxHeight : '0px',
    openItems : false,
    chooseIcon: false,
    iconOptions: [],
    icon: null,
    currentItemToChangeIcon: null
  }),
  computed: {
    verticalNavMenuItemsMin () { return this.$store.state.verticalNavMenuItemsMin },
    styleItems () {
      return { maxHeight: this.maxHeight }
    },
    itemIcon () {
      return (index) => {
        if (!((index.match(/\./g) || []).length > 1)) return 'CircleIcon'
      }
    },
    isGroupActive () {
      return (item) => {
        const path        = this.$route.fullPath
        let open          = false
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if ((path === item.url || routeParent === item.slug) && item.url) { open = true } else if (item.submenu) { func(item) }
            })
          }
        }

        func(item)
        return open
      }
    }
  },
  watch: {
    // OPEN & CLOSES DROPDOWN ON ROUTE CHANGE
    '$route' () {
      if (this.verticalNavMenuItemsMin) return

      const scrollHeight = this.scrollHeight

      // Collapse Group
      if (this.openItems && !this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = `${0}px`
        }, 50)

      // Expand Group
      } else if (this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = 'none'
        }, 300)
      }
    },
    maxHeight () {
      this.openItems = this.maxHeight !== '0px'
    },
    // OPEN AND CLOSES DROPDOWN MENU ON NavMenu COLLAPSE AND DEFAULT VIEW
    '$store.state.verticalNavMenuItemsMin' (val) {
      const scrollHeight = this.$refs.items.scrollHeight

      if (!val && this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = 'none'
        }, 300)
      } else {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = '0px'
        }, 50)
      }
      if (val && this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = '0px'
        }, 250)
      }
    }
  },
  methods: {
    editButtonClick(hash) {
      this.$store.commit('menuBuilder/setCurrentMenuToEdit', {
        hash: hash
      })
    },
    deleteButtonClick(hash) {
      this.$store.commit('menuBuilder/setCurrentMenuToDelete', {
        hash: hash
      })
    },
    async saveIcon() {
      this.chooseIcon = false

      this.$store.commit('auth/SET_MENU_ICON', {hash: this.currentItemToChangeIcon, icon: this.icon.value})

      document.querySelector(`[data-hash="${this.currentItemToChangeIcon}"]`).style.display = 'none'
      document.querySelector(`[data-hash="${this.currentItemToChangeIcon}"]`).setAttribute('data-remove', true)

      if(document.querySelector(`[data-hash="${this.currentItemToChangeIcon}"]`).parentElement.tagName.toLowerCase() === 'li') {
        document.querySelector(`[data-hash="${this.currentItemToChangeIcon}"]`).parentElement.setAttribute('data-remove', true)
      }

      let lastAnchor = ''

      let stopSearch = false

      document.querySelector('.vs-sidebar--items > div > section > div').children.forEach((item) => {
        if(!stopSearch) {
          if(item.tagName.toLowerCase() === 'span') {
            lastAnchor = item.getAttribute('data-hash')
          } else {

            if(item.tagName.toLowerCase() === 'li') {
              if(item.querySelector('div').getAttribute('data-hash') === this.currentItemToChangeIcon) {
                stopSearch = true
              }
            } else {
              if(item.getAttribute('data-hash') === this.currentItemToChangeIcon) {
                stopSearch = true
              }
            }
          }
        }
      })

      let parentHash = lastAnchor

      if(!parentHash) {
        parentHash = document.querySelector('.vs-sidebar--items > div > section > div > span').getAttribute('data-hash')
      }

      const menuItem = await this.$store.dispatch('auth/getMenuItemDetail', {hash: this.currentItemToChangeIcon})

      // this.$store.commit('auth/ADD_REMOVE_TAG', menuItem.hash)

      if(menuItem.hasOwnProperty('submenu')) {
        this.$vs.loading({type: 'default'})
        await this.$store.commit('auth/ADD_APPLICATION_MENU_ITEM', {
          parentHash: parentHash,
          hash: menuItem.hash,
          name: menuItem.name,
          url: menuItem.url,
          icon: menuItem.icon,
          submenu: menuItem.submenu
        })
        this.$vs.loading.close()

      } else {
        this.$vs.loading({type: 'default'})
        await this.$store.commit('auth/ADD_APPLICATION_MENU_ITEM', {
          parentHash: parentHash,
          hash: menuItem.hash,
          name: menuItem.name,
          url: menuItem.url,
          icon: menuItem.icon
        })
        this.$vs.loading.close()
      }

      this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)

      setTimeout(() => {
        document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
          item.classList.remove('router-link-exact-active')
          item.classList.remove('router-link-active')
        })

        document.querySelectorAll(`[data-remove="true"]`).forEach((item) => {
          item.style.display = 'none'
        })

        this.$vs.loading.close()
      }, 300)
    },
    async onEnd(event) {

      this.$vs.loading({
        container: '#menu-with-loading',
        scale: 0.6
      })

      const item = event.item

      if(event.to.parentElement.tagName.toLowerCase() === 'section') {

        this.chooseIcon = true

        this.currentItemToChangeIcon = item.querySelector('div').getAttribute('data-hash')

        let newParentHash = null

        let previous = event.item.previousSibling

        if(previous !== null) {
          if(previous.tagName.toLowerCase() !== 'li') {
            while(previous.tagName.toLowerCase() !== 'span') {
              previous = previous.previousSibling
            }

            newParentHash = previous.getAttribute('data-hash')

            event.item.setAttribute('data-parent-hash', newParentHash)
          }

          if(previous.tagName.toLowerCase() === 'li') {
            return
          }
        } else {

          if(event.item.parentElement.parentElement.tagName.toLowerCase() === 'ul') {
            newParentHash = event.item.parentElement.parentElement.parentElement.getAttribute('data-hash')
          }
        }

        const menuItem = await this.$store.dispatch('auth/getMenuItemDetail', {hash: item.getAttribute('data-hash')})

        let itemIndex = 0

        let startIndexCount = false

        let stopFor = false

        document.querySelector('.vs-sidebar--items > div > section > div').children.forEach((menuItem) => {

          if(!stopFor) {
            if(menuItem.getAttribute('data-hash') === parentHash) {
              startIndexCount = true
            } else {

              if(menuItem.getAttribute('data-hash') === itemHash){

                stopFor = true

              } else if(startIndexCount) {
                itemIndex++
              }
            }
          }
        })

        this.$store.commit('auth/ADD_REMOVE_TAG', menuItem.hash)

        if(menuItem.hasOwnProperty('submenu')) {
          this.$vs.loading({type: 'default'})
          await this.$store.commit('auth/ADD_APPLICATION_MENU_ITEM', {
            parentHash: parentHash,
            hash: menuItem.hash,
            name: menuItem.name,
            url: menuItem.url,
            icon: menuItem.icon,
            submenu: menuItem.submenu,
            index: itemIndex
          })
          this.$vs.loading.close()

        } else {
          this.$vs.loading({type: 'default'})
          await this.$store.commit('auth/ADD_APPLICATION_MENU_ITEM', {
            parentHash: parentHash,
            hash: menuItem.hash,
            name: menuItem.name,
            url: menuItem.url,
            icon: menuItem.icon,
            index: itemIndex
          })
          this.$vs.loading.close()
        }

        this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)

        setTimeout(() => {
          document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
            item.classList.remove('router-link-exact-active')
            item.classList.remove('router-link-active')
          })

          document.querySelectorAll(`[data-remove="true"]`).forEach((item) => {
            item.style.display = 'none'
          })

          this.$vs.loading.close()
        }, 300)

      } else {

        const itemHash = item.querySelector('div').getAttribute('data-hash')

        let toParentHash = null

        if(item.tagName.toLowerCase() === 'li') {
          toParentHash = item.parentElement.parentElement.parentElement.getAttribute('data-hash')
        }

        if(!(event.from === event.to) || (itemHash !== toParentHash)) {

          item.querySelector('div').setAttribute('data-parent-hash', toParentHash)

          const menuItem = await this.$store.dispatch('auth/getMenuItemDetail', {hash: itemHash})

          let itemIndex = 0

          let stopFor = false

          document.querySelector(`[data-hash="${toParentHash}"] > ul > div`).children.forEach((menuGroupItem) => {

            if(!stopFor) {
              if(menuGroupItem.querySelector('div') !== null) {
                if(menuGroupItem.querySelector('div').getAttribute('data-hash') === itemHash) {
                  stopFor = true
                } else {
                  itemIndex++
                }
              }
            }
          })

          this.$store.commit('auth/ADD_REMOVE_TAG', menuItem.hash)

          if(menuItem.hasOwnProperty('submenu')) {
            this.$vs.loading({type: 'default'})
            await this.$store.commit('auth/ADD_APPLICATION_MENU_ITEM', {
              parentHash: toParentHash,
              hash: menuItem.hash,
              name: menuItem.name,
              url: menuItem.url,
              icon: menuItem.icon,
              submenu: menuItem.submenu,
              index: itemIndex
            })
            this.$vs.loading.close()

          } else {

            // console.log('entered here')
            // console.log(menuItem)

            // document.querySelectorAll(`[data-hash="${menuItem.hash}"]`).forEach(item => {
            //   item.style.display = 'none'
            //   item.setAttribute('data-remove', true)
            // })

            // console.log(document.querySelectorAll(`[data-hash="${menuItem.hash}"]`))

            document.querySelectorAll(`[data-hash="${menuItem.hash}"]`).forEach(item => {
              if(item.getAttribute('data-parent-hash') === event.to.parentElement.parentElement.getAttribute('data-hash')) {
                item.style.display = 'none'
              }
            })

            this.$vs.loading({type: 'default'})
            await this.$store.commit('auth/ADD_APPLICATION_MENU_ITEM', {
              parentHash: toParentHash,
              hash: menuItem.hash,
              name: menuItem.name,
              url: menuItem.url,
              icon: menuItem.icon,
              index: itemIndex,
              remove: false
            })
            this.$vs.loading.close()
          }

          this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)

          setTimeout(() => {
            document.querySelectorAll('.router-link-exact-active.router-link-active').forEach((item) => {
              item.classList.remove('router-link-exact-active')
              item.classList.remove('router-link-active')
            })

            document.querySelectorAll(`[data-remove="true"]`).forEach((item) => {
              item.style.display = 'none'
            })

            this.$vs.loading.close()
          }, 300)

          this.$store.commit('menuBuilder/SET_UNSAVED_LAYOUT', true)
        }
      }

      setTimeout(() => {
        this.$vs.loading.close('#menu-with-loading > .con-vs-loading')
      }, 700)
    },
    clickGroup () {
      if (!this.openHover) {

        const thisScrollHeight = this.$refs.items.scrollHeight

        if (this.maxHeight === '0px') {
          this.maxHeight = `${thisScrollHeight}px`
          setTimeout(() => {
            this.maxHeight = 'none'
          }, 300)

        } else {
          this.maxHeight = `${thisScrollHeight}px`
          setTimeout(() => {
            this.maxHeight = `${0}px`
          }, 50)
        }

        this.$parent.$children.map((child) => {
          if (child.isGroupActive) {
            if (child !== this && !child.open && child.maxHeight !== '0px') {
              setTimeout(() => {
                child.maxHeight = `${0}px`
              }, 50)
            }
          }
        })
      }
    },
    mouseover () {
      if (this.openHover) {
        const scrollHeight = this.$refs.items.scrollHeight
        this.maxHeight   = `${scrollHeight}px`
      }
    },
    mouseout () {
      if (this.openHover) {
        const scrollHeight = 0
        this.maxHeight   = `${scrollHeight}px`
      }
    }
  },
  mounted () {
    this.openItems = this.open
    if (this.open) { this.maxHeight = 'none' }

    setTimeout(() => {
      this.iconOptions = this.$store.state.menuBuilder.icons
    }, 300)
  },
  created() {

  }
}

</script>


<style lang="scss">
.vs__dropdown-menu {
  z-index: 99999!important;
}
.cursorMove {
  cursor: move!important;
}
ul li {
    list-style-type: none;
}
.icon-select .vs__dropdown-menu {

  height: 90px !important;
}
@import "@/assets/scss/vuexy/components/verticalNavMenuGroup.scss"
</style>
